module.exports = __webpack_public_path__ + "static/img/xiangqing.02dcb0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/xiangqing.png
// module id = pyVj
// module chunks = 24